import clsx from 'clsx'
import { Spinner } from './spinner'

export interface LoadingViewProps {
  title: string
  className?: string
  spinnerSize?: 'sm' | 'md' | 'lg'
  'data-testid'?: string
}

export function LoadingView({ title, className, spinnerSize = 'lg', 'data-testid': dataTestId }: LoadingViewProps) {
  return (
    <div className={clsx('flex flex-col items-center justify-center', className)} data-testid={dataTestId}>
      <div className="mb-4">
        <Spinner size={spinnerSize} />
      </div>

      <h3 className="text-xl font-semibold font-ginto-nord-md text-gray-900 text-center">{title}</h3>
    </div>
  )
}
